<template>
  <div>
    <div class="d-flex justify-content-between align-items-baseline w-100">
      <h5 class="font-weight-bold text-secondary">
        <u>
          <router-link
            :event="!can('Manifest Details', 'no access') ? 'click' : ''"
            :to="{
              path: '/manifest-proto/' + item.id
            }"
          >MAN#{{ item.manifest }}</router-link>
          <!-- <router-link to="/manifest-proto">
            MAN#{{ item.manifest }}
          </router-link> -->
        </u>
      </h5>
      <h6 class="text-secondary">
        <b-dropdown
          id="dropdown-1"
          toggle-class="rounded-pill text-xs py-0 px-2 mr-1"
          menu-class="text-xs border-0 shadow-lg"
          variant="secondary"
        >
          <template v-slot:button-content>
            <b-icon-flag-fill
              :style="{ color: item.flag ? flagColor[item.flag] : '#eeeeee' }"
            ></b-icon-flag-fill>
          </template>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'delayed' ? '' : 'delayed'))"
          >
            <div>
              <b-icon-flag-fill
                style="color: #d476fd"
              ></b-icon-flag-fill>
              Delayed
            </div>
            <b-icon-check v-if="item.flag === 'delayed'"></b-icon-check>
          </b-dropdown-item>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'lost' ? '' : 'lost'))"
          >
            <div>
              <b-icon-flag-fill
                :style="{color: flagColor['lost']}"
              ></b-icon-flag-fill>
              Lost in Transit
            </div>
            <b-icon-check v-if="item.flag === 'lost'"></b-icon-check>
          </b-dropdown-item>
        </b-dropdown>
        <b-badge pill style="background: #419fcd; color: white;">
          Manifest
        </b-badge>
      </h6>
    </div>
    <h6 class="text-secondary text-left">
      {{ item.exporter }}
      <b-icon-dot></b-icon-dot>
      Date Created {{ new Date(item.dateCreated).toLocaleDateString(
        'en-US', {timeZone: timezone})}}
    </h6>
    <b-collapse
      :id="'result-card' + item.id"
      class="text-left text-xs"
    >
      <h6 class="text-muted mt-4 font-weight-bold" style="font-size: smaller;">
        ADDITIONAL DETAILS
      </h6>
      <b-table-lite
        ref="selectableTable"
        :items="itemToArray(item)"
        :fields="[
              'name',
              'value',
            ]"
        responsive="lg"
        :hover="true"
        id="search-results"
        class="text-xs"
      ></b-table-lite>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'SearchResultManifest',
  props: ['item', 'name', 'phoneNumber', 'destination', 'bol', 'accountNumber', 'timezone'],
  data() {
    return {
      excludedColumns: ['id', 'sender', 'origin', 'destination', 'manifest', 'bol',
        'outstandingBalance', 'dateCreated', 'type'],
      flagColor: {
        delayed: '#d476fd',
        lost: '#9bcb6c',
      },
    };
  },

  methods: {
    itemToArray(item) {
      const entries = Object.entries(item);
      const array = [];
      for (let i = 0; i < entries.length; i += 1) {
        if (!this.excludedColumns.includes(entries[i][0])) {
          array.push({
            name: entries[i][0],
            value: entries[i][1],
          });
        }
      }
      return array;
    },
  },
};
</script>

<style scoped>

</style>
